import { Suspense, useEffect, useState } from "react";
import "./index.scss"
// ** Router Import
import Router from "./router/Router";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./redux";
import { handleDeviceUid } from "./redux/reducers/deviceUId";
import { v4 as uuidv4 } from "uuid";
import AlertCustom from "./components/Alert/AlertCustom";
import { ToastType } from "./@types/ToastAlert";
import axiosInstance from "./configs/axiosConfig";
import { useLocation, useNavigate } from "react-router-dom";
import SpinnerComponent from "./@core/components/spinner/Fallback-spinner";
import { Routes } from "./router/routes";
import { handleAuthUser, handleRevokeToken } from "./redux/reducers/authUser";
import KeycloakService from "./service/keycloak";
import { UserAccount } from "./@types/UserAccount";
import { handleUserAccount } from "./redux/reducers/userAccount";
import { handleAccountFeatures } from "./redux/reducers/accountFeatures";
import { AuthUser } from "./@types/AuthUser";
import { returnErrorOrDefaultMessage } from "./utility/responseUtil";
import useErrorHandle from "./utility/hooks/useErrorHandle";
import { useMount } from "./utility/GeneralUtil";

const App = () => {
  const uid = useSelector<RootState, string>((state) => state.deviceUId.uid);
  const handleError = useErrorHandle();
  const toastAlert = useSelector<RootState, ToastType>(
    (state) => state.alert.toast
  );
  const authUser:AuthUser = useSelector<RootState, AuthUser>((state) => state.authUser.authUser);
  const [isLoadingUser, setIsOnLoadingUser] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  // const isRtl = useSelector((state) => state.layout.isRTL);
  useEffect(() => {
    const createUniqueID = () => {
      let uniqueId = uuidv4();
      dispatch(handleDeviceUid(uniqueId));
    };
    if (uid === "") createUniqueID();
    // dispatch(handleShowAlert({type:'info', children :'ola mundo'}))

    console.log("---------" + uid);
  }, [uid, dispatch]);

  useMount(() => {
    console.log("update v1")
    setIsOnLoadingUser(true);
    const updateAuthUser = () => {
      let authUser = window.localStorage.getItem("authUser");
      if(authUser) {
        dispatch(handleAuthUser(JSON.parse(authUser)));
      }
    }
    const fetchUserAccount = () => {
      axiosInstance
        .get("/user")
        .then((response) => {
          let userAccount: UserAccount = response.data;
          dispatch(handleUserAccount(userAccount));
          const accounts = userAccount.accounts;
          if (accounts && accounts.length > 0) {
            const savedIdRaw = window.localStorage.getItem("activeAccountId");
            const savedId = savedIdRaw ? Number(savedIdRaw) : null;
            const activeAcc =
              (savedId !== null && accounts.find(a => a.astvId === savedId)) ||
              accounts[0];
            const astvId = activeAcc?.astvId;
            if (astvId) {
              axiosInstance
                .get(`/account/${astvId}/features`)
                .then((featuresResponse) => {
                  dispatch(handleAccountFeatures(featuresResponse.data));
                })
                .catch(() => {})
                .finally(() => { setIsOnLoadingUser(false); });
              return;
            }
          }
          setIsOnLoadingUser(false);
        })
        .catch((err) => {
          console.log(err);
          returnErrorOrDefaultMessage(err, "Erro ao obter dados da conta");
          handleError.handleError("error-01", "");
          setIsOnLoadingUser(false);
        });
    };
    updateAuthUser();
    fetchUserAccount();
    
  });

  useEffect(() => {
    console.log(" redux user app")
    console.log(authUser)
  }, [authUser])

  // desabilitado pois ainda não temos autenticação
  useEffect(() => {
    const checkSession = () => {
      axiosInstance
        .get("/check/token")
        .then((response) => {
          //
          
          let firstPathname = pathname;
          if(pathname.lastIndexOf("/") && pathname.lastIndexOf("/") !== 0 ){
            let paths = pathname.split("/");
            firstPathname = "/" + paths[1];
          }
          let router = Routes.find(r => {return (r.path === pathname) || (r.path.includes(firstPathname) && r.hasParams) })
          if (router && !router.logged && !firstPathname.includes("erro")) {
            //navigate("/");
          } else if (router === undefined) {
            navigate("/error");
          }
        })
        .catch((err) => {
          console.log(err)
          console.log("--- session not ok, redirect to login ---" + pathname);
          handleRevokeToken();
          KeycloakService.CallLogout('');
        })
        .finally(() => {
        });
    };
    if (pathname !== "/error") checkSession();
    console.log(pathname)

  }, [navigate, pathname]);
  //fim

  return (
    <>
      <Suspense fallback={null}>
        { isLoadingUser  ? <SpinnerComponent /> : <Router />}
      </Suspense>
      <AlertCustom
        visible={toastAlert.show}
        type={toastAlert.type}
        children={toastAlert.children}
      ></AlertCustom>
    </>
  );
};

export default App;
